import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Container, Grid, Icon, Label, Segment } from 'semantic-ui-react';
import { searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { DropdownWithCheckboxes } from '@package/components';
import cx from 'classnames';

const OffboardView = ({ content, location }) => {
  const [selectedTags, setSelectedTags] = useState([]);

  const dispatch = useDispatch();

  const getIntersection = (arr1, arr2) => {
    if (!arr1 || !arr2) return [];
    const set2 = new Set(arr2);
    return arr1.filter((item) => set2.has(item));
  };

  useEffect(() => {
    let path =
      process.env.NODE_ENV === 'development'
        ? `/CMS${location.pathname}`
        : location.pathname;
    if (path.endsWith('/')) path = path.slice(0, -1);
    dispatch(
      searchContent('/', {
        portal_type: ['TextBlock'],
        fullobjects: true,
        b_size: 999,
        'path.query': path,
        'path.depth': 1,
      }),
    );
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [dispatch]);

  const hasLoaded = useSelector((state) => state.search?.loaded || false);

  const items = useSelector((state) => state.search?.items);

  let filteredBlocksCount = 0;
  const grouped = Object.values(
    items
      .filter((item) => item.content?.data)
      .reduce((acc, item) => {
        if (!acc[item.heading]) {
          acc[item.heading] = { heading: item.heading, blocks: [] };
        }
        if (
          getIntersection(item.offboarding_tags, selectedTags).length ===
          selectedTags.length
        ) {
          acc[item.heading].blocks.push(item);
          filteredBlocksCount += 1;
        }
        return acc;
      }, {}),
  );

  const allTags = [
    ...new Set(items.flatMap((item) => item.offboarding_tags)),
  ].sort();

  const toggleTagSelection = (tag) => {
    if (selectedTags.indexOf(tag) > -1) {
      setSelectedTags(selectedTags.filter((sTag) => sTag !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  return (
    <Container id="page-document">
      <style>{`
        a.ui.label {
          pointer-events: none;
          text-decoration: none;
        }
        .ui.label.selectable {
          cursor: pointer;
          font-size: 0.8rem;
        }
        .ui.label.selected {
          background-color: #C61A27;
          color: white;
        }
        .textblock {
          border-bottom: 1px solid #e5e5e5;
          margin-bottom: 1.5em;
          padding-bottom: 1em;
        }
        .offboarding-filter {
          column-gap: 1em;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 24px;
        }
        .offboarding-filter .dropdown-wrapper {
          flex-basis: 350px;
        }
        .offboarding-filter .reset-filters {
          display: flex;
          align-items: center;
        }
        .offboarding-filter .reset-filters span {
          color: #C61A27;
          cursor: pointer;
        }
      `}</style>
      <h1 className="documentFirstHeading">{content.title}</h1>
      {hasLoaded ? (
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={12} tablet={12} computer={9} largeScreen={9}>
              <div className="offboarding-filter">
                <DropdownWithCheckboxes
                  title={'Filtern'}
                  items={allTags.map((tag) => {
                    return { token: tag, title: tag };
                  })}
                  onChange={(evt, data) => {
                    toggleTagSelection(data.value);
                  }}
                  filterStatus={selectedTags}
                  initialOpen={true}
                />
                {selectedTags.length > 0 && (
                  <div className="reset-filters">
                    <span
                      onClick={() => setSelectedTags([])}
                      size="tiny"
                      onKeyDown={() => setSelectedTags([])}
                      role="button"
                      tabIndex={0}
                    >
                      <FormattedMessage
                        id="Reset all filters"
                        defaultMessage="Reset all filters"
                      />
                    </span>
                  </div>
                )}
              </div>
              {filteredBlocksCount === 0 && <p>Keine Ergebnisse.</p>}
              {grouped
                .filter((group) => group.blocks.length > 0)
                .map((group, index) => (
                  <div key={`gr-${index}`} style={{ marginBottom: '2em' }}>
                    <h2>{group.heading}</h2>
                    {group.blocks.map((block) => (
                      <div key={block['@id']} className="textblock">
                        <Link
                          style={{ float: 'right' }}
                          to={`${flattenToAppURL(block['@id'])}/edit`}
                        >
                          <Icon className="edit outline" title="Bearbeiten" />
                        </Link>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: block.content.data,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ))}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : (
        <span>Lade ...</span>
      )}
    </Container>
  );
};

export default OffboardView;
